    <div class="relative">
      <!-- Leading icon -->
      @if (leadingIcon(); as ic) {
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground pointer-events-none z-10">
          <app-icon [name]="ic" size="sm"></app-icon>
        </div>
      }

      <!-- Trigger -->
      <button type="button" (click)="toggle()" (keydown)="onKeydown($event)" [disabled]="disabledState()"
        [attr.aria-expanded]="open()" aria-haspopup="listbox"
        class="cs-trigger w-full h-10 pr-9 rounded-lg border bg-card text-left text-sm text-foreground transition-all duration-200 focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
        [class.pl-9]="leadingIcon()" [class.pl-3]="!leadingIcon()"
        [class.cs-open]="open()" [class.border-border]="!invalid()" [class.border-destructive]="invalid()">
        <span class="block truncate" [class.text-foreground]="hasValue()" [class.text-muted-foreground]="!hasValue()">
          {{ selectedLabel() || placeholder() }}
        </span>
      </button>

      <!-- Chevron -->
      <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <svg class="cs-chevron w-4 h-4 text-muted-foreground transition-transform duration-200"
          [class.cs-chevron-open]="open()" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      <!-- Panel -->
      @if (open()) {
        <div class="cs-panel" [class.cs-panel-up]="dropUp()" role="listbox">
          @if (searchable()) {
            <div class="cs-search-wrap">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z" />
              </svg>
              <input #searchInput type="text" class="cs-search" [value]="search()" autocomplete="off"
                placeholder="Search..." (input)="onSearch($event)" (keydown)="onKeydown($event)" />
            </div>
          }

          <ul #list class="cs-list">
            @for (opt of filtered(); track opt.value; let i = $index) {
              <li role="option" class="cs-option"
                [class.cs-option-multi]="multiple()"
                [attr.aria-selected]="isSelected(opt)" [attr.aria-disabled]="opt.disabled || null"
                [class.cs-selected]="isSelected(opt)"
                [class.cs-active]="i === activeIndex()"
                [class.cs-disabled]="opt.disabled"
                (click)="selectOption(opt)" (mouseenter)="activeIndex.set(i)">
                @if (multiple()) {
                  <span class="cs-checkbox" [class.cs-checkbox-on]="isSelected(opt)">
                    @if (isSelected(opt)) {
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                      </svg>
                    }
                  </span>
                }
                <span class="truncate">{{ opt.label }}</span>
                @if (!multiple() && isSelected(opt)) {
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                }
              </li>
            } @empty {
              <li class="cs-empty">No options</li>
            }
          </ul>
        </div>
      }
    </div>
